import { useSharedAlarmGroup } from '@hakimo-ui/hakimo/data-access';
import {
  AlarmGroupMedia,
  AlarmGroupProvider,
  AlarmGroupTimeline,
  CameraFeedMode,
  normalizeAlarmGroupLocation,
} from '@hakimo-ui/hakimo/feature-shared';
import { UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';
import { NotFound, QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { Alert } from '@hakimo-ui/shared/ui-base';
import { useSearchParams } from 'react-router-dom';

function SharedAlarmGroupDetails({ sharedToken }: { sharedToken: string }) {
  const queryResult = useSharedAlarmGroup(sharedToken);

  return (
    <QueryResult
      queryResult={queryResult}
      errorFormatter={() => (
        <div className="mx-auto max-w-screen-2xl p-6">
          <Alert type="error">
            This link is expired or invalid. Please ask the sender for a new
            link.
          </Alert>
        </div>
      )}
    >
      {(data) => (
        <div className="container mx-auto h-[100%]">
          <AlarmGroupProvider
            key={data.id}
            alarmGroupId={data.id}
            alarms={data.alarms}
            location={normalizeAlarmGroupLocation(data.location, data.tenantId)}
            product={UnifiedMonitoringProduct.SCAN}
          >
            <div className="flex h-[100%] min-h-[100%] flex-col p-4 pb-8">
              <div className="flex-1">
                <AlarmGroupMedia globalCamMode={CameraFeedMode.ALARM_VIDEO} />
              </div>
              <AlarmGroupTimeline isCompressedTimeline={false} />
            </div>
          </AlarmGroupProvider>
        </div>
      )}
    </QueryResult>
  );
}

export function SharedAlarmGroupRoot() {
  const [searchParams] = useSearchParams();
  const sharedToken = searchParams.get('sharedToken');

  if (!sharedToken) {
    return (
      <NotFound message="Missing shared token in shared alarm group URL" />
    );
  }

  return <SharedAlarmGroupDetails sharedToken={sharedToken} />;
}

export default SharedAlarmGroupRoot;
